<template>
    <div class="card is-min-width-800" v-if="mountedLoadingEnd">
      <header class="bandeau-modal card-header">
      </header>
      <div class="pdl-20px pdr-20px">
        <div class="center">
          <div class="columns is-gapless">
            <div class="column mgt-40px">
              <h1 class="title is-size-3">
                <span>
                  {{ $t('listeDemandeImpression.popUpAddImpression.title') }}
                </span>
              </h1>
            </div>
          </div>
        </div>
        <div class="card-content">
          <error-msg-component
            :messages="messages"
            :error="error"
            :messagesChampsVide="messagesChampsVide"
            :champsVide="champsVide"
            :withEmplyFields="true"
            title="general.problemOccurred"
            @close="error = $event"/>
          <div class="columns is-multiline">
            <div class="column is-6">
              <b-field :label="$t('listeDemandeImpression.popUpAddImpression.dateDemande')"
                      class="obligatoire">
                <b-datepicker show-week-number
                              v-model="demandeImpression.dateDemande"
                              icon="calendar-today"
                              nearby-selectable-month-days editable>
                </b-datepicker>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field class="obligatoire"
                      :label="$t('listeDemandeImpression.popUpAddImpression.etat')">
                <b-select v-model="demandeImpression.etat" expanded>
                  <option v-for="item in etats"
                          :key="item.key"
                          :value="item.key">
                    {{ $t(item.libelle) }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field
                :label="$t('listeDemandeImpression.popUpAddImpression.quantite')">
                  <qd-numberinput
                    v-model="demandeImpression.quantite"
                    :min="0"
                    :placeholder="$t('listeDemandeImpression.popUpAddImpression.quantite')"
                    :controls="false">
                  </qd-numberinput>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="$t('editionDemandeImpression.infoGenerale.typeOt')">
                  <b-select v-model="demandeImpression.typeOtId"
                    expanded>
                    <option :key="null" :value="null"></option>
                    <option v-for="type in typesOTImpression"
                          :key="type.id"
                          :value="type.id">
                      {{ type.libelle }}
                    </option>
                  </b-select>
                </b-field>
            </div>
            <div class="column is-6">
              <b-field
                :label="$t('listeDemandeImpression.popUpAddImpression.demandeur')">
                <b-autocomplete
                  v-model="demandeur"
                  :placeholder="$t('listeDemandeImpression.popUpAddImpression.demandeur')"
                  :data="contactsDemandeur"
                  field="nomPrenom"
                  :loading="isFetchingContact"
                  icon="magnify"
                  :open-on-focus="true"
                  @input="getContactsDemandeurDebounce"
                  @select="option =>
                    demandeImpression.contactDemandeurId = option ? option.id : null">
                  <template #empty>
                    {{$t(`general.autocomplete.${!isFetchingContact ? 'noRslt' : 'search'}`)}}
                  </template>
                </b-autocomplete>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field
                :label="$t('listeDemandeImpression.popUpAddImpression.receveur')">
                <b-autocomplete
                  v-model="receveur"
                  :placeholder="$t('listeDemandeImpression.popUpAddImpression.receveur')"
                  :data="contactsReceveur"
                  field="nomPrenom"
                  :loading="isFetchingContact"
                  icon="magnify"
                  :open-on-focus="true"
                  @input="getContactsReceveurDebounce"
                  @select="option =>
                    demandeImpression.contactReceveurId = option ? option.id : null">
                  <template #empty>
                    {{$t(`general.autocomplete.${!isFetchingContact ? 'noRslt' : 'search'}`)}}
                  </template>
                </b-autocomplete>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="$t('listeDemandeImpression.popUpAddImpression.nomVariante')">
                <b-input v-model="demandeImpression.nomVariante"
                  :placeholder="$t('listeDemandeImpression.popUpAddImpression.nomVariante')">
                </b-input>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="$t('listeDemandeImpression.popUpAddImpression.tags')">
                <query-tags-tag-input
                  :position="'is-right'"
                  :tooltipLabel="$t('editionCampagne.tagInfo')"
                  v-model="demandeImpression.tags"
                  field="tag"
                  :moduleTag="constantes.moduleDemandeImpression">
                </query-tags-tag-input>
              </b-field>
            </div>
            <div v-if="moduleCampagneActive" class="column is-12">
              <b-field
                :label="$t('listeDemandeImpression.popUpAddImpression.campagne')">
                <b-autocomplete
                  v-model="campagne"
                  :placeholder="$t('listeDemandeImpression.popUpAddImpression.campagne')"
                  :data="campagnes"
                  field="libelle"
                  :loading="isFetchingCampagne"
                  icon="magnify"
                  @input="getCampagnesDebounce"
                  @select="option =>
                    demandeImpression.campagneId = option ? option.id : null">
                  <template #empty>
                    {{$t(`general.autocomplete.${!isFetchingCampagne
                      ? 'noRslt' : 'search'}`)}}
                  </template>
                  <template slot-scope="props">
                    <div class="columns is-vcentered">
                        <div class="column is-8 is-prewrap">
                            {{ props.option.libelle }}
                        </div>
                        <div class="column is-4 has-text-right"
                          v-if="props.option.urlLogoCampagne">
                          <div class="max-height-img-view-80">
                            <img :src="props.option.urlLogoCampagne"
                              class="max-width-100 max-height-80">
                          </div>
                        </div>
                    </div>
                  </template>
                </b-autocomplete>
              </b-field>
            </div>
          </div>
          <footer>
            <b-field>
              <div class="is-pulled-left boutonAction">
                <a class="button" @click="$parent.close()">
                  {{ $t('general.button.cancel')}}
                </a>
              </div>
              <div class="is-pulled-left boutonAction">
                <a class="button is-addOrEdit"
                   @click="checkPermissions(constantes.permDemandeImpression.maj) ?
                 sauvegardeAsync() : showPopUp()">
                  {{ $t('general.button.sauvegarder') }}
                </a>
              </div>
            </b-field>
          </footer>
        </div>
      </div>
    </div>
  </template>
<script>

import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import { cloneDeep } from 'lodash';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { PARAMETRES_INTERNE_KEYS, PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { getAllWithTiers as getAllContactByTiers } from '@/api/contacts';
import { getAllByTiers } from '@/api/contactTiers/index';
import { getAll as getAllCampagnes } from '@/api/campagne';
import { createAll } from '@/api/logistique/demandeImpression';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import genererDemandeImpression from '@/services/logistique/demandeImpression/genererDemandeImpression';
import getContactFullName from '@/services/contact/contactHelper';
import { DEMANDE_IMPRESSION } from '@/configuration/logistique/permissionsLogistiqueConf';
import {
  ETAT_DEMANDE_IMPRESSION,
  ETAT_RECEPTIONNE,
} from '@/configuration/logistique/demandeImpression/demandeImpressionConf';
import formatDate from '@/services/general/formatIsoDate';
import validation from '@/services/logistique/demandeImpression/validationDemandeImpression';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/logistique/demandeImpression/translateDemandeImpression';
import { IMPRESSION_AFFICHE } from '@/configuration/logistique/typeOt/typeOtConfig';
import queryTagsTagInput from '@/components/general/tagInput/queryTagsTagInput';
import { DEMANDE_IMPRESSION as moduleDemandeImpression } from '@/configuration/parametrage/tagConf';

const Parametres = createNamespacedHelpers('parametres');
const Permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'p_editionDemandeImpressionDispo',
  props: {
    clientId: {
      type: String,
      required: true,
    },
    dispositifs: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      demandeImpression: null,
      contactsDemandeur: [],
      contactsReceveur: [],
      campagnes: [],
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      isFetchingContact: false,
      isFetchingCampagne: false,
      receveur: null,
      dispositif: null,
      campagne: null,
      demandeur: null,
      mountedLoadingEnd: false,
      constantes: {
        ETAT_DEMANDE_IMPRESSION,
        permDemandeImpression: DEMANDE_IMPRESSION,
        ETAT_RECEPTIONNE,
        moduleDemandeImpression,
      },
    };
  },
  components: {
    errorMsgComponent,
    queryTagsTagInput,
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
      parametre: 'parametre',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActive: 'societeActive',
    }),
    etats() {
      return this.constantes.ETAT_DEMANDE_IMPRESSION;
    },
    moduleCampagneActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.campagne.key);
    },
    typesOTImpression() {
      return this.parametre(PARAMETRES_KEYS.typeOt)
        .filter(type => type.actionInterventionOt === IMPRESSION_AFFICHE);
    },
    materielTypes() {
      return this.parametre(PARAMETRES_KEYS.materielType);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
      loadParametres: 'loadParametres',
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    getContactsDemandeurDebounce: debounce(async function getContacts(search) {
      if (!this.clientId) return;
      this.contactsDemandeur = [];
      try {
        this.isFetchingContact = true;
        const getContact = getAllContactByTiers({
          query: {
            auto: search,
            societeId: this.societeActive.id,
            archive: false,
            type: 'Client',
            tiersId: [this.clientId],
          },
        });
        const getPortailContact = getAllByTiers(this.clientId);
        this.contactsDemandeur = await Promise.all([getContact, getPortailContact])
          .then((result) => {
            return result[0].data.result.items.concat(result[1].data.result.items)
              .map(item => {
                item.nomPrenom = getContactFullName(item);
                return item;
              })
              .reduce((acc, current) => {
                const doublon = acc.find(item => item.id === current.id);
                if (!doublon) {
                  acc.push(current);
                }
                return acc;
              }, [])
              .filter((item) => item.nomPrenom.toLowerCase().trim().match(`.*${search?.toLowerCase().trim()}.*`));
          });
        this.isFetchingContact = false;
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        this.isFetchingContact = false;
      }
    }, 300),
    getContactsReceveurDebounce: debounce(async function getContacts(search) {
      if (!this.clientId) return;
      this.contactsReceveur = [];
      try {
        this.isFetchingContact = true;
        const getContact = getAllContactByTiers({
          query: {
            auto: search,
            societeId: this.societeActive.id,
            archive: false,
            type: 'Client',
            tiersId: [this.clientId],
          },
        });
        const getPortailContact = getAllByTiers(this.clientId);
        this.contactsReceveur = await Promise.all([getContact, getPortailContact])
          .then((result) => {
            return result[0].data.result.items.concat(result[1].data.result.items)
              .map(item => {
                item.nomPrenom = getContactFullName(item);
                return item;
              })
              .reduce((acc, current) => {
                const doublon = acc.find(item => item.id === current.id);
                if (!doublon) {
                  acc.push(current);
                }
                return acc;
              }, [])
              .filter((item) => item.nomPrenom.toLowerCase().trim().match(`.*${search?.toLowerCase().trim()}.*`));
          });
        this.isFetchingContact = false;
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        this.isFetchingContact = false;
      }
    }, 300),
    getCampagnesDebounce: debounce(async function getCampagne(search) {
      let marquesIds = [];
      if (this.demandeImpression.client && this.demandeImpression.client.tiersMarques) {
        marquesIds = this.demandeImpression.client.tiersMarques.map(marque => marque.marqueId);
      }
      try {
        this.isFetchingCampagne = true;
        this.campagnes = (await getAllCampagnes({
          query: {
            auto: search,
            societeId: this.societeActive.id,
            actif: true,
            marqueIds: marquesIds,
            avecLogo: true,
          },
        })).data.result.items;
        this.isFetchingCampagne = false;
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        this.isFetchingCampagne = false;
      }
    }, 300),
    createDemandeImpressionModel() {
      const demande = genererDemandeImpression();
      demande.societeId = this.societeActive.id;
      demande.typeOtId = this.societeActive.typeOtImpressionId;
      demande.dateDemande = new Date();
      demande.quantite = 1;
      demande.nomVariante = '';
      demande.etat = this.constantes.ETAT_RECEPTIONNE;
      return demande;
    },
    async sauvegardeAsync() {
      const demandesImpressions = [];
      this.dispositifs.forEach(dispositif => {
        const demandeImpression = cloneDeep(this.demandeImpression);
        demandeImpression.dateDemande = formatDate(demandeImpression.dateDemande);
        demandeImpression.dispositifId = dispositif.id;
        if (dispositif?.emplacement?.clientId) {
          demandeImpression.clientId = dispositif?.emplacement?.clientId;
        } else {
          demandeImpression.clientId = this.clientId;
        }
        if (dispositif.materiels.length > 0
          && this.getFirstMaterielTypeColor(dispositif.materiels)) {
          demandeImpression.couleur = this.getFirstMaterielTypeColor(dispositif.materiels);
        }
        demandesImpressions.push(demandeImpression);
      });
      await this.createAllDemandeImpressionAsync(demandesImpressions);
    },
    async createAllDemandeImpressionAsync(demandesImpressions) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await createAll(demandesImpressions);
        this.popUpPrevention = false;
        messageSucces(this.$i18n.t('detailClient.dispositif.message.successCreationDemande'));
        this.$parent.close();
      } catch (e) {
        this.isError = true;
        if (e.response?.data?.error) {
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messages = [];
          validation(e.response, this.messages);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
        }
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    getFirstMaterielTypeColor(materiels) {
      return materiels.find(mat => mat.typeId && mat.type?.couleur)?.type?.couleur;
    },
  },
  async mounted() {
    this.demandeImpression = this.createDemandeImpressionModel();
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.campagne.key]);
      await this.loadParametres([PARAMETRES_KEYS.typeOt, PARAMETRES_KEYS.materielType]);
      await this.getContactsDemandeurDebounce('');
      await this.getContactsReceveurDebounce('');
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
      this.mountedLoadingEnd = true;
    }
  },
};
</script>
